import searchName from "./searchName";

function handleFilter(
  parameter: string,
  operator: string,
  value: string,
  buildup: any
): boolean {
  const valueFloatTest = parseFloat(value);

  if (parameter === "templateId") {
    return buildup.template.id === value;
  }

  if (!isNaN(valueFloatTest)) {
    switch (operator) {
      case "equalTo": {
        return buildup[parameter] === valueFloatTest;
      }
      case "lessThan": {
        return buildup[parameter] < valueFloatTest;
      }
      case "lessThanOrEqualTo": {
        return buildup[parameter] <= valueFloatTest;
      }
      case "greaterThan": {
        return buildup[parameter] > valueFloatTest;
      }
      case "greaterThanOrEqualTo": {
        return buildup[parameter] >= valueFloatTest;
      }
    }
  }
  switch (operator) {
    case "doesNotContain": {
      if (value === "") {
        return true;
      }
      return searchName(buildup[parameter], value, "and");
    }
    case "contains": {
      return searchName(buildup[parameter], value, "or");
    }
    default: {
      return false;
    }
  }
}

export default handleFilter;
